/* import __COLOCATED_TEMPLATE__ from './contact-block.hbs'; */
import { classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './contact-block.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationContactBlock extends Component {
  @service currentPractice;

  @reads('client._isDirty') isDirty;
  @reads('currentPractice.featureWidgetPaymentMethodEnabled') featureWidgetPaymentMethod;

  @computed('careCoordinatorMode')
  get labelPrefix() {
    return this.careCoordinatorMode ? '' : 'Your ';
  }
}
